export const SlideType = Object.freeze({
	slide: 'Slide',
	section: 'Section',
	quizSlide: 'QuizSlide',
	multipleChoiceSlideTemplate: 'MultipleChoiceSlideTemplate',
	resultsSlideTemplate: 'ResultsSlideTemplate',
	learningObject: 'LearningObject'
});